<template>
  <div className="animated">
    <b-card>
      <b-card-header>
        <i class="icon-menu mr-1"></i>Voucher List
      </b-card-header>
      <b-card-body>
        <vouchers></vouchers>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
  import Vouchers from './Table'

  export default {
    name: 'partner-voucher',
    components: {
      Vouchers
    }
  }
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
  }
</style>
